import React from "react";

const CustomPopupIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 180 180"
    style={{ width: 24, height: 24 }} // Ajusta el tamaño según tus necesidades
  >
    <style>{`.st0{fill:#0000008a;}`}</style>
    <g>
      <path
        className="st0"
        d="M152.9,133.8l-35.9-33.6c-1.7-1.6-4.4-1.5-6,0.3l-12.8,14.6c-1.6,1.8-1.4,4.6,0.3,6.2l35.9,33.6
        c1.7,1.6,4.4,1.5,6-0.3l12.8-14.6C154.8,138.2,154.6,135.4,152.9,133.8z"
      />
      <path
        className="st0"
        d="M111.6,54.6C104.9,34.6,86.7,22,67.3,22c-5.1,0-10.3,0.9-15.3,2.7c-24.5,8.7-37.5,36.3-29,61.6
        c6.7,20,24.9,32.6,44.4,32.6c5.1,0,10.3-0.9,15.4-2.7C107.1,107.4,120.1,79.8,111.6,54.6z
        M78.4,103.7c-3.6,1.3-7.4,2-11.2,2c-14.6,0-27.6-9.5-32.3-23.8c-3-8.9-2.4-18.5,1.6-26.9c4-8.5,11-14.8,19.6-17.9l0,0
        c3.6-1.3,7.4-1.9,11.2-1.9c14.6,0,27.6,9.5,32.3,23.7c3,8.9,2.4,18.5-1.6,26.9C94,94.3,87.1,100.7,78.4,103.7z"
      />
    </g>
  </svg>
);

export default CustomPopupIcon;
